// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import AdvancedCreateComment from './advanced_create_comment';

export default AdvancedCreateComment;
